import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

function ServiceCard({ service, highlighted = false }) {
  const imageTone = highlighted
    ? "from-blue-950/80 via-blue-700/25 to-transparent"
    : "from-slate-950/55 via-slate-950/10 to-transparent";
  const cardTone = highlighted
    ? "border-blue-200 bg-blue-600 text-white shadow-[0_28px_80px_rgba(37,99,235,0.22)]"
    : "border-slate-200/80 bg-white text-slate-950 shadow-[0_18px_60px_rgba(15,23,42,0.06)]";
  const numberTone = highlighted
    ? "bg-white/15 text-white ring-white/15"
    : "bg-white/90 text-blue-600 ring-slate-200/80";
  const bodyTextTone = highlighted ? "text-blue-50/90" : "text-slate-500";
  const actionTone = highlighted
    ? "border-white/15 text-white group-hover:border-white/30"
    : "border-slate-200 text-slate-700 group-hover:border-blue-200 group-hover:text-blue-600";
  const iconTone = highlighted
    ? "bg-white text-blue-600"
    : "bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white";

  return (
    <Link
      to={service.path}
      className={`group relative flex min-h-[430px] flex-col overflow-hidden rounded-[2rem] border transition duration-300 hover:-translate-y-2 hover:shadow-[0_30px_90px_rgba(37,99,235,0.18)] ${cardTone}`}
    >
      <div className="relative h-48 overflow-hidden bg-slate-100">
        {service.heroImageUrl ? (
          <img
            src={service.heroImageUrl}
            alt={service.heroImageAlt || service.name}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          />
        ) : null}
        <div className={`absolute inset-0 bg-gradient-to-t ${imageTone}`} />
        <div className={`absolute left-5 top-5 flex h-12 w-12 items-center justify-center rounded-2xl text-sm font-medium ring-1 backdrop-blur-md ${numberTone}`}>
          {service.number}
        </div>
      </div>

      <div className="flex flex-1 flex-col p-7">
        <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-current/10 px-3 py-1 text-[11px] font-light uppercase tracking-[0.18em] opacity-70">
          Service
        </div>

        <h3 className="text-2xl font-light leading-tight">{service.name}</h3>
        <p className={`mt-4 flex-1 text-base font-light leading-7 ${bodyTextTone}`}>
          {service.shortDescription}
        </p>

        <div className={`mt-7 flex items-center justify-between border-t pt-5 text-sm font-medium transition ${actionTone}`}>
          <span>View service</span>
          <span className={`flex h-9 w-9 items-center justify-center rounded-full transition duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 ${iconTone}`}>
            <ArrowUpRight size={16} />
          </span>
        </div>
      </div>
    </Link>
  );
}

export default ServiceCard;
